
import { Component, Prop, Vue } from "vue-property-decorator";

import { APPROVED_BY_HO_OA_STATUS, REJECTED_BY_HO_OA_STATUS } from "@/constants/services";

const CLASS = "service-notification";

const ICONS = {
  checkmarkCircle: "checkmark-circle",
  alertCircle: "alert-circle",
};

@Component
export default class ServiceNotification extends Vue {
  @Prop({ type: String, default: "" }) readonly status?: string;

  get icon() {
    const { status } = this;

    if (status === APPROVED_BY_HO_OA_STATUS) return ICONS.checkmarkCircle;

    if (status === REJECTED_BY_HO_OA_STATUS) return ICONS.alertCircle;

    return "";
  }

  get text() {
    const { status } = this;

    if (status === APPROVED_BY_HO_OA_STATUS) return this.$t("text.approved");

    if (status === REJECTED_BY_HO_OA_STATUS) return this.$t("text.rejected");

    return "";
  }

  get classes() {
    const { status } = this;

    return {
      [`${CLASS}_${status}`]: status,
    };
  }
}
